<div
    class="badge fx-row fx-layout-align-start-center fx-layout-gap-8"
    [class.header]="headerStyle"
    [class.charging]="isCharging"
    [dialogLink]="headerStyle ? undefined : ['tx', tx?.txId]"
    [class.compact]="compact"
    [class.endedAsFaded]="endedAsFaded"
    [class.ended]="tx?.endTime || !credible"
>
    <!-- session icon -->
    <mat-icon svgIcon="k-session"></mat-icon>

    <!-- ev and date info -->
    <div class="info fx-column">
        <ng-container [ngSwitch]="customerPrivacyEnabled">
            <label *ngSwitchCase="false" [attr.title]="possibleEvName">{{
                (ev$ | async)?.name || (ev$ | async)?.evModel || possibleEvName
            }}</label>

            <!-- If customer privacy enabled, show only evModel, or 'EV' -->
            <label *ngSwitchDefault [attr.title]="possibleEvName">{{ (ev$ | async)?.evModel || 'EV' }}</label>
        </ng-container>

        <span class="date" *ngIf="!compact">{{
            tx?.startTime
                | adjustUtcDate
                    : { format: 'DD.MM.yyyy HH:mm', time: (currentTime$ | async), showUtcTimeLabel: showUtcLabel }
        }}</span>
    </div>

    <!-- spacer -->
    <div class="fx-flex"></div>

    <!-- session info and location -->
    <!-- right of wrapper, max 30 -->
    <div class="session fx-flex-30" flexLayout="column">
        <div class="details">
            <ng-container *ngIf="isCharging">
                <b>{{ tx?.power / 1000 | number: '1.0-0' }} </b>kW<ng-container *ngIf="tx?.soc != null"
                    >, <b>{{ tx?.soc }}</b
                    >%&#8230;</ng-container
                >
            </ng-container>
            <ng-container *ngIf="!isCharging">
                <b>+{{ tx?.chargedEnergyKwh ? (tx.chargedEnergyKwh | number: '1.1-1') : '0.0' }} </b>kWh<span
                    *ngIf="!tx?.endTime"
                    >&#8230;</span
                ><span *ngIf="tx?.endTime && endedAsFaded"
                    >, {{ tx.endTime | adjustUtcDate: { ago: true, time: (currentTime$ | async) } }}</span
                >
            </ng-container>
        </div>
        <div class="location" *ngIf="!compact">{{ tx?.evseName || tx?.evseId }}</div>
    </div>
</div>
